<template>
  <el-dialog title="客服修改"
             :visible.sync="dialogFormVisible"
             custom-class="min-dialog"
             center
             :close-on-click-modal="false"
             :modal="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="名称" :label-width="formLabelWidth" prop="isperson">
            <el-select v-model="form.isperson" placeholder="请选择" style="width: 100px" disabled>
              <el-option
                v-for="item in controlData.isperson"
                :key="item.value"
                :label="item.text+''"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="form.deptname" auto-complete="off" :required="true"
                      style="width:260px" disabled></el-input>
          </el-form-item>
        </el-col>

        <el-row :gutter="24">
          <el-col :span="21">
            <el-form-item label="销售客服" :label-width="formLabelWidth" prop="serveuname" treeContent>
              <el-input v-model="form.serveuguid" auto-complete="off" v-if="false"></el-input>
              <CommonTree ref="treeDserial" :treeHeight="180" :searchText="form.serveuname" @check="changeServer"
                          :isShowCheckBox="false"></CommonTree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData">保 存</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {saveData, getDetail, getControlData, getListData} from '@/api/set/externaldept';
  import {getParameterDetail} from '@/api/set/parameter';
  import {independentDept} from '@/api/set/dept';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        dialogFormVisible: false,
        form: {  //表单数据
          unitguid: '',
          isperson: 0,
          deptname: '',
          serveuguid: '',
          serveuname: '',
        },
        formLabelWidth: '120px',
        controlData: {
          isperson: []
        },
        rules: {////////定义正则验证字段。

        },
      }
    },
    methods: {
      changeServer(guids, names, arr) {
        this.form.serveuguid = guids;
        this.form.serveuname = names;
      },
      show() {
        this.form.unitguid = null
        this.dialogFormVisible = true
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {

            saveData(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            });
          }
        })
      },
      initData(unitguid) {
        this.form.unitguid = unitguid
        getDetail({unitguid: unitguid}).then(response => {
          this.initRowData(response.data.obj);
        });
      },

      initRowData(formdata) {
        this.form = formdata
      }
    },

    mounted() {
      getControlData().then(response => {
        this.controlData = response.data.obj
      });
    },
    components: {}
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF
  }
</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/CustomerService.vue